"use strict";

const animationDuration = 3000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = t => t * (2 - t);
const animateCountUp = el => {
  let frame = 0;
  const countTo = parseInt(el.getAttribute("target"), 10);
  const currentValue = parseInt(el.innerHTML);
  if (currentValue > 0) {
    return;
  }
  const counter = setInterval(() => {
    frame++;
    const progress = easeOutQuad(frame / totalFrames);
    const currentCount = Math.round(countTo * progress);
    if (parseInt(el.innerHTML, 10) !== currentCount) {
      el.innerHTML = currentCount;
    }
    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};
//# sourceMappingURL=countUp.js.map